import script from "./ProcessContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessContent.vue?vue&type=script&setup=true&lang=js"

import "./ProcessContent.vue?vue&type=style&index=0&id=1803a20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1803a20c"]])

export default __exports__